// extracted by mini-css-extract-plugin
export default {"box":"SXZ4MxZEMBQcn_VPNf74","titleBox":"FkVrzwczGLzbKoHZSPaS","icon":"SSowoCYPKpUxuRGXgmei","button":"SNkSMng1XWRnQU92rUa3"};